"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetIsLabelSevere = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpTooltips_1 = require("../help/LabelHelpTooltips");
const severe = 'severe';
/**
 * Note: this isn't used in the new labels dialog because it doesn't use the FormikRadioButtonGroup
 */
function useSetIsLabelSevere({ disabled, isLabelValue, initial }) {
    const [isSevere, setIsSevere] = react_1.default.useState(initial);
    const handleChange = react_1.default.useCallback((value) => {
        if (!disabled) {
            setIsSevere(value === severe);
        }
    }, [disabled]);
    const title = isLabelValue ? catalog_messages_1.Messages.labelSetDefaultVisibilityLevel() : catalog_messages_1.Messages.labelSetVisibilityLevel();
    const buttonList = [
        {
            label: (react_1.default.createElement("div", { style: { marginBottom: '4px' } },
                react_1.default.createElement(LabelHelpTooltips_1.HelpTextDiv, null, catalog_messages_1.Messages.labelStandardVisibility()))),
            testId: 'standard',
            value: 'standard',
        },
        {
            label: (react_1.default.createElement("div", { style: { marginBottom: '4px' } },
                react_1.default.createElement(LabelHelpTooltips_1.HelpTextDiv, null, catalog_messages_1.Messages.labelHighVisibility()))),
            testId: severe,
            value: severe,
        },
    ];
    const element = (react_1.default.createElement(widgets_1.RadioButtonWithLabelGroupWidget, { removeLeftMargin: true, checkedIndex: buttonList.findIndex(b => b.value === (isSevere ? 'severe' : 'standard')), handleChange: handleChange, buttonList: buttonList, label: react_1.default.createElement("div", { style: { display: 'inline-flex', marginBottom: '6px' } },
            react_1.default.createElement(LabelHelpTooltips_1.HelpTextDiv, null,
                title,
                react_1.default.createElement(LabelHelpTooltips_1.VisibilityTooltip, { isLabelValue: isLabelValue }))), style: { width: '100%', marginTop: '40px', opacity: disabled ? widgets_1.TabStyles.Opacity.Disabled : undefined }, testId: 'label-severity-toggle' }));
    return [
        element,
        isSevere,
    ];
}
exports.useSetIsLabelSevere = useSetIsLabelSevere;
//# sourceMappingURL=useSetIsLabelSevere.js.map